<template>
    <div class="modal fade history-filter-modal forgetwithdrawModal-cl" id="ChangeAndWithdrawPassword" data-bs-backdrop="static" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-keyboard="false">
        <div class="modal-dialog modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <div class="thm-heading">
                        <h3>{{ $t('change-password', 'Change password') }}</h3>
                    </div>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" v-if="$auth?.user?.last_login_at" @click="refreshData()"></button>
                </div>
                <div class="modal-body">
                    <form class="withdraw_password_content">
                        <div class="cmn_withdraw_cl position-relative">
                            <div class="input-relative">
                                <img src="@/assets/images/input-password.svg" alt="input-password" class="input-icn-img">
                                <input :type="oldPasswordFieldType" :placeholder="$t('enter-current-password', 'Enter Current Password')+'*'" class="form-control profit-input" :class="{'border border-danger': init.oldPassword && checkValidation?.oldPassword?.length > 0}" 
                                @input="oldPassword = $helper.sanitizeDetails('oldLoginPassword', oldPassword); validate();" v-model="oldPassword">
                                <i @click="togglePasswordVisibility('oldPasswordFieldType')"  
                                    :class="['fas', 'togglePassword', oldPasswordFieldType === 'text' ? 'fa-eye' : 'fa-eye-slash']">
                                </i>
                            </div>
                            <!-- errors -->
                            <section v-if="init.oldPassword && checkValidation?.oldPassword?.length > 0">
                                <section v-for="(err, index) in checkValidation?.oldPassword" :key="index">
                                    <span class="error-messages-text">&#x2022; {{ $t(err.lang, err.error) }}</span>
                                </section>
                            </section>
                        </div>
                    
                        <div class="cmn_withdraw_cl position-relative">
                            <div class="input-relative">
                                <img src="@/assets/images/input-password.svg" alt="input-password" class="input-icn-img">
                                <input :type="newPasswordFieldType" minLength="8" maxlength="20" required="required" autocomplete="off"
                                :placeholder="$t('enter-new-password', 'Enter New Password')+'*'" class="form-control profit-input" 
                                :class="{'border border-danger': init.newPassword && checkValidation?.password?.length > 0}" v-model="newPassword" @input="newPassword = $helper.sanitizeDetails('password', newPassword, 20); validate();">
                                <i @click="togglePasswordVisibility('newPasswordFieldType')"  
                                    :class="['fas', 'togglePassword', newPasswordFieldType === 'text' ? 'fa-eye' : 'fa-eye-slash']">
                                </i>
                            </div>
                            <!-- errors -->
                            <section v-if="init.newPassword && checkValidation?.password?.length > 0">
                                <section v-for="(err, index) in checkValidation?.password" :key="index">
                                    <span class="error-messages-text">&#x2022; {{ $t(err.lang, err.error) }}</span>
                                </section>
                            </section>
                        </div>

                        <div class="cmn_withdraw_cl position-relative">
                            <div class="input-relative">
                                <img src="@/assets/images/input-password.svg" alt="input-password" class="input-icn-img">
                                <input :type="confirmPasswordFieldType" class="form-control profit-input" :placeholder="$t('enter-confirm-new-password', 'Enter Confirm New Password')" required="required" autocomplete="off" minLength="8" maxlength="20"
                                v-model="confirmPassword" :class="{'border border-danger': init.confirmPassword && checkValidation?.confirmPassword?.length > 0}"
                                @input="confirmPassword = $helper.sanitizeDetails('password', confirmPassword, 20); validate();">
                                <i @click="togglePasswordVisibility('confirmPasswordFieldType')"  
                                    :class="['fas', 'togglePassword', confirmPasswordFieldType === 'text' ? 'fa-eye' : 'fa-eye-slash']">
                                </i>
                            </div>
                            <!-- errors -->
                            <section v-if="init.confirmPassword && checkValidation?.confirmPassword?.length > 0">
                                <section v-for="(err, index) in checkValidation?.confirmPassword" :key="index">
                                    <span class="error-messages-text">&#x2022; {{ $t(err.lang, err.error) }}</span>
                                </section>
                            </section>
                        </div>

                        <template v-if="$siteSettings?.data?.business_type == 2 && !$auth?.user?.last_login_at && !$auth?.user?.phone">
                            <div class="cmn_withdraw_cl position-relative">
                                <div class="input-relative">
                                    <img src="@/assets/images/input-password.svg" alt="input-password" class="input-icn-img">
                                    <input :type="withdrawPasswordFieldType" maxlength="20" class="form-control profit-input" :placeholder="$t('enter-withdraw-password', 'Enter Withdraw Password') + '*'" 
                                    :class="{'border border-danger': init.withdrawPassword && checkValidation?.withdrawPassword?.length > 0}" v-model="withdrawPassword" 
                                    @input="withdrawPassword = $helper.sanitizeDetails('withdrawPassword', withdrawPassword, 20); validate();">
                                    <i @click="togglePasswordVisibility('withdrawPasswordFieldType')"  
                                        :class="['fas', 'togglePassword', withdrawPasswordFieldType === 'text' ? 'fa-eye' : 'fa-eye-slash']">
                                    </i>
                                </div>
                                <!-- errors -->
                                <section v-if="init.withdrawPassword && checkValidation?.withdrawPassword?.length > 0">
                                    <section v-for="(err, index) in checkValidation?.withdrawPassword" :key="index">
                                        <span class="error-messages-text">&#x2022; {{ $t(err.lang, err.error) }}</span>
                                    </section>
                                </section>
                            </div>

                            <div class="cmn_withdraw_cl position-relative">
                                <div class="input-relative">
                                    <img src="@/assets/images/input-password.svg" alt="input-password" class="input-icn-img">
                                    <input :type="confirmWithdrawPasswordFieldType" maxlength="20" :placeholder="$t('enter-conf-withdraw-pass', 'Enter Confirm Withdraw Password') + '*'" class="form-control profit-input" v-model="confirmWithdrawPassword" 
                                    :class="{'border border-danger': init.confirmWithdrawPassword && checkValidation?.confirmWithdrawPassword?.length > 0}" @input="confirmWithdrawPassword = $helper.sanitizeDetails('withdrawPassword', confirmWithdrawPassword, 20); validate();">
                                    <i @click="togglePasswordVisibility('confirmWithdrawPasswordFieldType')"  
                                        :class="['fas', 'togglePassword', confirmWithdrawPasswordFieldType === 'text' ? 'fa-eye' : 'fa-eye-slash']">
                                    </i>
                                </div>
                                <!-- errors -->
                                <section v-if="init.confirmWithdrawPassword && checkValidation?.confirmWithdrawPassword?.length > 0">
                                    <section v-for="(err, index) in checkValidation?.confirmWithdrawPassword" :key="index">
                                        <span class="error-messages-text">&#x2022; {{ $t(err.lang, err.error) }}</span>
                                    </section>
                                </section>
                            </div>
                        </template>
                        <button @click.prevent="submitChangePassword()" type="button" class="btn_submit_cl">{{ $t('change-password', 'Change Password')}}</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import validate from "@/modules/authorization/services/authValidation"
import { callChangePasswordServiceFunction } from "@template/utils"
export default {
    name: 'ChangePassword',
	data() {
        return {
            oldPassword: '',
            newPassword: '',
            confirmPassword: '',
            withdrawPassword: '',
            confirmWithdrawPassword: '',
            init:{
                oldPassword:false,
                newPassword:false,
                confirmPassword:false,
                withdrawPassword:false,
                confirmWithdrawPassword:false,
            },
            oldPasswordFieldType: 'password',
            newPasswordFieldType: 'password',
            confirmPasswordFieldType: 'password',
            withdrawPasswordFieldType: 'password',
            confirmWithdrawPasswordFieldType: 'password',
            validationErrors : null
        }
    },
    computed:{
		checkValidation() {
            return this.validationErrors;
        }
	},
    methods: {
        togglePasswordVisibility(fieldName) {
            this[fieldName] = this[fieldName] === 'password' ? 'text' : 'password';            
        },
        submitChangePassword() {
            this.toggleInit(true);
            if(Object.keys(this.validate()).length != 0) return;
            this.callChangePasswordServiceFunction();
        },
        toggleInit(bool){
            this.init={
                oldPassword:bool,
                newPassword:bool,
                confirmPassword:bool,
                withdrawPassword:bool,
                confirmWithdrawPassword:bool,
            }
        },
        validate(){
            this.validationErrors = validate.areFieldsValid(
                'change-password',
                this.oldPassword,
                this.newPassword,
                this.confirmPassword,
                this.withdrawPassword,
                this.confirmWithdrawPassword,
                this.$siteSettings?.data?.business_type == 2 && !this.$auth?.user?.last_login_at && !this.$auth?.user?.phone
            );
            return this.validationErrors;
        },
        async callChangePasswordServiceFunction() {
            if (this.$auth?.user?.isDemo) {
                this.$errorToast("Password Change Is Not Allowed For Demo Users");
                return;
            }
            this.loading = true;
			this.$store.dispatch('setGlobalLoader', true);
            let response = await callChangePasswordServiceFunction(this.oldPassword, this.newPassword, this.confirmPassword, this.withdrawPassword)
            if(!response?.changeErrorRes){
                this.loading = false;
                this.$store.dispatch('setGlobalLoader', false);
                this.refreshData();
                this.$helper.closeModal('ChangeAndWithdrawPassword')
                setTimeout(()=>{
                    window.location.reload();
                },500) 
            }
            else{
                this.loading = false;
                this.$store.dispatch('setGlobalLoader', false);
            }
        },
        refreshData(){
            this.oldPassword = '';
            this.newPassword = '';
            this.confirmPassword = '';
            this.withdrawPassword = '';
            this.confirmWithdrawPassword = '';
            this.init = {
                oldPassword:false,
                newPassword:false,
                confirmPassword:false,
                withdrawPassword:false,
                confirmWithdrawPassword:false,
            };
            this.oldPasswordFieldType= 'password';
            this.newPasswordFieldType= 'password';
            this.confirmPasswordFieldType= 'password';
            this.withdrawPasswordFieldType= 'password';
            this.confirmWithdrawPasswordFieldType= 'password';
            this.validationErrors = null
        }
    }
}
</script>

<style scoped>
.modal.fade.history-filter-modal.forgetwithdrawModal-cl {
    z-index: 1054;
}
</style>